import Auth from "@aws-amplify/auth"

export const getAuthorizationHeader = async () => {
    return { 
        Authorization: `${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}` 
    };
}
